import { models } from 'powerbi-client';

const reportIds = {
    'np': 'b2ad6e2b-fcf9-4b05-8cd6-66a05084bfaa',
    'pp': '5f90e634-953a-4081-b1bb-0963d9f44869',
    'p': 'f56af717-43b9-44ec-81e1-daf4a3353438'
};

const datasetIds = {
    'np': '3bffefa4-643e-4938-8c07-d9bdcf4a5d79',
    'pp': 'c4bc067c-578b-4c8c-9e99-73024ea89a77',
    'p': '533dca03-8ab3-451e-bfa8-61573197a90f'
};

const npPbiTabs = [
    {
        id: 'summary',
        name: 'Portfolio Summary',
        pageNamenp: '2b621824b3cba596a625',
        pageNamepp: '2b621824b3cba596a625',
        pageNamep: '2b621824b3cba596a625'
    },
    {
        id: 'detail',
        name: 'Portfolio Detail',
        pageNamenp: 'ReportSection8a020f99caeb010e2b5c',
        pageNamepp: 'ReportSection8a020f99caeb010e2b5c',
        pageNamep: 'ReportSection8a020f99caeb010e2b5c'
    },
    {
        id: 'brand',
        name: 'Brand Insights',
        pageNamenp: 'ReportSectionaadfe14405579c1cb9b8',
        pageNamepp: 'ReportSectionaadfe14405579c1cb9b8',
        pageNamep: 'ReportSectionaadfe14405579c1cb9b8'
    },
    {
        id: 'comparison',
        name: 'Portfolio Comparison',
        pageNamenp: 'ReportSection633726d3515ac002780a',
        pageNamepp: 'ReportSection633726d3515ac002780a',
        pageNamep: 'ReportSection633726d3515ac002780a'
    },
    {
        id: 'customer',
        name: 'Customer Insights',
        pageNamenp: 'ReportSection1722f5552dc5e588c469',
        pageNamepp: 'ReportSection1722f5552dc5e588c469',
        pageNamep: 'ReportSection1722f5552dc5e588c469'
    }
    // {
    //     id: 'metrics_master',
    //     name: 'Portfolio Metrics Master',
    //     pageNamenp: '30b3d279121e85e92ec7',
    //     pageNamepp: '30b3d279121e85e92ec7',
    //     pageNamep: '30b3d279121e85e92ec7',
    //     reportTxt: false
    // }
];

const reportIdsForGen2 = {
  'np': '3651e715-a511-4049-9ec0-405cfa5b3318',
  'pp': '337fe6ff-87ea-4c2b-8940-6713df90a36c',
  'p': '55708483-3b91-4196-bfb4-08808fecc4f5'
}

const globalCycleTriggerPbiTabs = [
    {
        id: 'globalCycleTrigger',
        name: 'Global Cycle Trigger Queue',
        pageNamenp: 'ReportSectiond06ccc28b7b70c705e50',
        pageNamepp: 'ReportSectiond06ccc28b7b70c705e50',
        pageNamep: 'ReportSectiond06ccc28b7b70c705e50'
    }
];

const skuDetailPbiTabs = [
    {
        id: 'skuDetails',
        name: 'SKU Details',
        pageNamenp: 'ReportSection357820218678b5961889',
        pageNamepp: 'ReportSection357820218678b5961889',
        pageNamep: 'ReportSection357820218678b5961889'
    }
];

const getPbiEnv = () => {
    const host = window.location.host;
    switch (host) {
        case "dtv-tpo.preprod.mypepsico.com":
            return "pp";
        case "dtv-tpo.dev.mypepsico.com":
        case "dtv-tpo.qa.mypepsico.com":
            return "np";
        default:
            return "p";
    }
};

export const getPbiUrlConfigs = () => buildPbiUrlConfigs(npPbiTabs, reportIds);
export const getPbiUrlConfigsForGlobalCycles = () => buildPbiUrlConfigs(globalCycleTriggerPbiTabs, reportIdsForGen2);
export const getPbiUrlConfigsForSkuDetails = () => buildPbiUrlConfigs(skuDetailPbiTabs, reportIdsForGen2);

const buildPbiUrlConfigs = (tabsConfig, reportIds) => {
    const tabs = [];
    const pbiEnv = getPbiEnv();
    const reportId = reportIds[pbiEnv];

    tabsConfig.forEach((elem) => {
        const pageName = elem[`pageName${pbiEnv}`];
        // const reportSectionTxt = elem.reportTxt ? 'ReportSection' : '';
        const pbiUrl = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&pageName=${pageName}&pbiEnv=${pbiEnv}`;
        tabs.push({
            id: elem.id,
            name: elem.name,
            pbi_url: pbiUrl,
        });
    });
    return tabs;
};

export const getReportId = () => {
    return reportIds[getPbiEnv()];
}

export const getReportIdForGen2 = () => {
  return reportIdsForGen2[getPbiEnv()];
}

export const getDatasetId = () => {
    return datasetIds[getPbiEnv()];
}

export const getDisabledTabs = () => {
    const tabs = npPbiTabs.filter((tab) => tab.disabled);
    const disableTab = tabs.length ? tabs.map((tab) => tab.id) : [];
    return disableTab;
}

export const getEmbedConfig = (url, pbiEmbedToken) => ({
    type: 'report',
    id: getReportIdForGen2(),
    embedUrl: url,
    accessToken: pbiEmbedToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: { visible: false },
        pageNavigation: { visible: false }
      },
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToWidth
      }
    }
});
